module.exports = __webpack_public_path__ + "assets/108145033fb4d6bc6c6e3d458e4394e9.png";